abstract class BaseReportDataItem {
    value: string | number | null;
    formatted: string;

    constructor(value: string | number | null) {
        if (value === null || value === undefined) {
            this.value = null;
            this.formatted = '';
            return;
        }
        // set value and cast to number if possible
        if (typeof value === 'string') {
            const parsedValue = parseFloat(value);
            this.value = isNaN(parsedValue) ? value : parsedValue;
        } else {
            this.value = value;
        }

        this.formatted = this.formatValue(value);
    }

    abstract formatValue(value: string | number): string;
}

class PercentDataItem extends BaseReportDataItem {
    formatValue(value: string | number): string {
        const num = Number(value);
        if (isNaN(num)) return '';
        let formattedValue = `${Math.round(num)}%`;

        this.formatted = formattedValue;

        return formattedValue;
    }
}

class MoneyDataItem extends BaseReportDataItem {
    formatValue(value: string | number): string {
        const num = Number(value);
        if (isNaN(num)) return '';

        let formattedValue = Math.round(num).toLocaleString();

        this.formatted = formattedValue;
        return formattedValue;
    }
}

class StringDataItem extends BaseReportDataItem {
    formatValue(value: string | number): string {
        this.formatted = String(value);
        return String(value);
    }
}

interface BaseReportRawData {
    locationCode: string;
    locationName: string;
    classCode: string;
    className: string;

    // For child hierarchies
    parentClientClassCode?: string | null;

    category?: string;
    categorySortOrder?: number;
    trend?: number | null;
    vertical?: string; // optional vertical label for certain reports
    brand?: string; // optional brand label for certain reports
}

interface BaseReportParsedData {
    locationCode: string;
    locationName: string;
    classCode: string;
    className: string;

    // For child hierarchies
    parentClientClassCode: string | null;

    category?: string;
    trend?: number | null;
    month?: string;
    vertical?: string;
    brand?: string;
}

export type {
    BaseReportRawData,
    BaseReportParsedData,
}

export {
    BaseReportDataItem,
    PercentDataItem,
    MoneyDataItem,
    StringDataItem,
}